import React from 'react';
import { useLocalize } from 'localize-react';
import { useLocation } from 'wouter';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import ArrowIcon from '@transferz/fe-component-library/src/components/icons/ArrowIcon';
import BottomDrawer from '@transferz/fe-component-library/src/components/bottomDrawer/BottomDrawer';
import { Button } from '@transferz/fe-component-library/src/components/button/Button';
import { getCurrencyInfo } from '../../../../utils/utils';
import styles from './additional-payment.module.css';

interface IAdditionalPaymentProps {
  isPopupOpen: boolean;
  params: any;
  setIsPopupOpen: Function;
  currencyCode: string;
  journeyChangeData: any;
}
export const AdditionalPayment: React.FC<IAdditionalPaymentProps> = ({
  params,
  isPopupOpen,
  setIsPopupOpen,
  currencyCode,
  journeyChangeData,
}) => {
  const { translate } = useLocalize();
  const [, setLocation] = useLocation();
  const title = `${translate('journey_additionalPayment')} ${getCurrencyInfo(currencyCode)?.symbol}${journeyChangeData?.paymentAmount} ${translate('journey_paymentNeeded')}`;

  return (
    <BottomDrawer
      title={title}
      isOpen={isPopupOpen}
      onClose={() => setIsPopupOpen(false)}
      enableDesktopView={true}
    >
      <Typography variant="body1">{translate('journey_changeAcceptedCheck')}</Typography>
      <div className={`${styles.additionalPaymentFooter} d-flex justify-content-flex-end`}>
        <Button
          className={`mr-16 ${styles.close}`}
          label={translate('close')}
          priority="secondary"
          onClick={() => setIsPopupOpen(false)}
          data-button-id="close-additional-payment"
        />
        <Button
          className={styles.additionalPaymentBtn}
          label={translate('journey_goToPayment')}
          priority="primary"
          onClick={() => setLocation(`/booking/${params.bookingCode}/journeyChange/${journeyChangeData?.id}/payment`)}
          icon={<ArrowIcon width={15} color="light" direction="right" />}
          iconPosition="right"
          data-button-id="go-payment-page"
          fullWidth
        />
      </div>
    </BottomDrawer>
  );
};
